import LegalPageLayout from "@/components/LegalPageLayout";
import { COMPANY, FULL_DISCLAIMER, AI_DISCLAIMER, AI_PERFORMANCE_NOTE, REGULATORY_NOTICE } from "@/lib/site";

export default function Disclaimer() {
  return (
    <LegalPageLayout
      meta={{
        title: "Disclaimer — Adviserz | Quant Core Technologies Private Limited",
        description:
          "Disclaimer for Adviserz, a brand of Quant Core Technologies Private Limited. Adviserz is not registered with SEBI as a Research Analyst or Investment Adviser. Information is provided for informational and educational purposes only.",
        canonical: "https://adviserz.in/disclaimer",
      }}
      overline="Legal"
      title="Disclaimer"
      intro={FULL_DISCLAIMER}
      sections={[
        {
          h: "Regulatory status",
          p: [
            REGULATORY_NOTICE.replace("Regulatory Status: ", ""),
            "Nothing on this website should be interpreted as a representation that the company holds any registration, licence, approval or authorisation from the Securities and Exchange Board of India or from any other regulator. No SEBI registration number is claimed and no regulatory endorsement is implied.",
            "Accordingly, the website does not offer investment advisory services, research analyst services, portfolio management services, or paid investment recommendations, and does not collect payment for any such service.",
          ],
        },
        {
          h: "No investment advice",
          p: [
            "All content, data, analytics, screens, visualisations, model outputs and written material made available through this website are provided for informational, educational and analytical purposes only.",
            "Such content does not constitute investment advice, a research report, a recommendation, an offer, a solicitation, or an inducement to buy, sell or hold any security, derivative or other financial instrument, and is not tailored to the objectives, financial situation or needs of any person.",
          ],
        },
        {
          h: "AI & analytics disclaimer",
          p: [AI_DISCLAIMER, AI_PERFORMANCE_NOTE],
        },
        {
          h: "Research and analytics content",
          p: [
            "Where the platform displays quantitative research, charts, market analysis, derivatives analytics or algorithmically generated outputs, such material is analytical and informational in nature.",
            "Methodologies, assumptions and data windows materially affect analytical outputs. Different assumptions may produce materially different results. Users should independently evaluate any methodology before relying on it in any way.",
          ],
        },
        {
          h: "Market risk",
          p: [
            "Investments in securities and financial instruments are subject to market risks, including the possible loss of the principal amount invested. Derivatives carry additional risks, including leverage risk, and may not be suitable for all persons.",
            "Past performance, historical data, back-tested results and simulated outcomes are not indicative of, and do not guarantee, future results.",
          ],
        },
        {
          h: "No guaranteed outcomes",
          p: [
            "The company makes no representation or warranty, express or implied, regarding profitability, accuracy rates, assured returns, fixed returns, risk-free outcomes or any particular result arising from the use of this website or its content.",
          ],
        },
        {
          h: "Data accuracy and third-party sources",
          p: [
            "Data displayed on the platform may originate from third-party providers, exchanges, public disclosures and news sources. While reasonable efforts are made to maintain quality, the company does not warrant the accuracy, completeness, timeliness or continued availability of any data, and is not responsible for errors, omissions, delays or interruptions.",
          ],
        },
        {
          h: "User responsibility",
          p: [
            "Users are solely responsible for their own decisions. Users should conduct their own research and consult a SEBI-registered financial professional, and where relevant a tax or legal professional, before making any investment decision.",
          ],
        },
        {
          h: "Limitation of liability",
          p: [
            `To the maximum extent permitted by applicable law, ${COMPANY.legalName}, its directors, employees and affiliates shall not be liable for any direct, indirect, incidental, consequential or special loss or damage arising from the use of, or reliance on, this website or any content made available through it.`,
          ],
        },
        {
          h: "Scope of this disclaimer",
          p: [
            "The presence of this disclaimer does not, by itself, authorise the provision of any regulated service. The platform has been structured so as not to offer regulated investment advisory or research analyst services in the absence of the applicable registration.",
          ],
        },
      ]}
    />
  );
}
